import { Injectable } from '@angular/core';
import { FiltersConfig, FilterMetadataType } from '../components/filter-config';
import { TSGuid } from '../models/ts-guid.model';
import { FilterService } from './filter.service';
import { CURRENT_USER } from '../constants/business.constants';

@Injectable()
export class EmailDigestFilterService {
    constructor(
        private _filterService: FilterService
    ) { }

    getAdhocFilterDefaultInstance(data): FiltersConfig {
        const filtersConfig = new FiltersConfig();

        filtersConfig.id = new TSGuid().toString();
        if (data.dataType === 'date') {
            data.metadataType = FilterMetadataType.Date;
        } else if (data.dataType === 'text' && data.source.length > 0) {
            data.metadataType = data.controlType || FilterMetadataType.Dropdown;
            // adhoc metadataType MSD/CheckBox/Dropdown id is uniquely identifies
            // add multi same adhoc, id will repeat in filter panel
            filtersConfig['adhocId'] = data.id;
        } else if (data.dataType === 'entity') {
            data.metadataType = data.controlType;
            filtersConfig.currentUser = CURRENT_USER;
        } else {
            data.metadataType = FilterMetadataType.TextBox;
        }
        filtersConfig.dataType = data.dataType;
        filtersConfig.metadataType = data.metadataType;
        filtersConfig.fields = data.attrDefId;
        filtersConfig.selectedOperator = this._filterService.getDefaultOperator(data.metadataType).value;
        filtersConfig.operators = this._filterService.getOperatorOptions(data.metadataType);

        filtersConfig.value = this._filterService.getDefaultValue(data.metadataType);
        filtersConfig.title = data.name;
        filtersConfig.source = data.source;
        filtersConfig.disable = false;
        if (data.dataType === 'text' && data.source.length > 0) {
            filtersConfig.source = data.source.map(item => ({
                name: item,
                value: item
            }));
        }
        return filtersConfig;
    }

    convertEmailFilterToFilter(item, type) {
        let filterConfig = new FiltersConfig();
        if (!item.id && item.metadataType === FilterMetadataType.TextBox) {
            item.metadataType = FilterMetadataType.Subject;
        }
        filterConfig = this._filterService.getNewFilterDefaultInstance(item.metadataType, item.metadataType, false, false, true);
        const metadataType = filterConfig.metadataType;
        filterConfig.selectedOperator = item.operator;
        filterConfig.value = item.value;
        switch (metadataType) {
            case FilterMetadataType.Subject:
                if (type === 'file') {
                    filterConfig.fields = ['file subject'];
                }
                break;
            case FilterMetadataType.Team:
                filterConfig.selectedOperator = this._formatTeamOperator(item.operator);
                if (typeof item.value === 'string') {
                    // web 1.0 team can selsected all, web 2.0 change team as source/submitter model, can not selected all
                    filterConfig.value = '';
                } else if (item.value && item.value.length > 0) {
                    filterConfig.value = item.value.map(value => ({
                        id: value
                    }));
                } else {
                    item.value = [];
                }
                break;
            case FilterMetadataType.Source:
            case FilterMetadataType.Submitter:
            case FilterMetadataType.Participants:
                if (item.value && item.value.length > 0) {
                    filterConfig.value = item.value.map(value => ({
                        id: value
                    }));
                } else {
                    item.value = [];
                }
                break;
            case FilterMetadataType.Entities:
                if (item.value && item.value.length > 0) {
                    filterConfig.value = item.value.map(value => ({
                        id: value
                    }));
                } else {
                    item.value = [];
                }
                filterConfig.relationshipType = item.relationship;
                break;
            case FilterMetadataType.MSD:
            case FilterMetadataType.CheckBox:
            case FilterMetadataType.Dropdown:
                filterConfig.fields = item.fields;
                filterConfig.source = item.source;
                filterConfig.value = item.value || [];
                filterConfig.title = item.title;
                // adhoc metadataType MSD/CheckBox/Dropdown id is uniquely identifies
                // add multi same adhoc, id will repeat in filter panel
                filterConfig['adhocId'] = item.id;
                if (item.dataType) {
                    filterConfig.dataType = item.dataType;
                }
                break;
            case FilterMetadataType.Entity:
            case FilterMetadataType.ED:
            case FilterMetadataType.MED:
            case FilterMetadataType.MET:
                if (item.value && item.value.length > 0) {
                    filterConfig.value = item.value.map(value => ({
                        id: value
                    }));
                } else {
                    item.value = [];
                }
                filterConfig.title = item.title;
                filterConfig.id = item.id;
                filterConfig.dataType = item.dataType;
                break;
            case FilterMetadataType.TextBox:
                filterConfig.title = item.title;
                filterConfig.id = item.id;
                filterConfig.dataType = item.dataType;
                if (item.fields) {
                    filterConfig.fields = item.fields;
                }
                break;
            case FilterMetadataType.Date:
                filterConfig.title = item.title;
                filterConfig.id = item.id;
                filterConfig.dataType = item.dataType;
                if (item.fields) {
                    filterConfig.fields = item.fields;
                }
                break;
            default:
                break;
        }
        return filterConfig;
    }

    private _formatTeamOperator(operator) {
        const operators = {
            'Submitted by': 'submittedby',
            'Not Submitted by': 'notsubmittedby',
            'Sourced to': 'sourcedto',
            'Not Sourced to': 'notsourcedto'
        };
        return operators[operator];
    }
}

